var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxConferance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "f0c91108-9583-4531-94fd-f810041a1853",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3,5.752a.51.51,0,0,0-.127.017,35.016,35.016,0,0,0-3.512,2.6,1.787,1.787,0,0,0-.922,1.314V7.465A1.741,1.741,0,0,0,10,5.724H4.644A1.741,1.741,0,0,0,2.9,7.465v5.07a1.741,1.741,0,0,0,1.741,1.741H10a1.741,1.741,0,0,0,1.742-1.741V10.286c0,.585.35.871.922,1.343a19.126,19.126,0,0,0,3.512,2.6.487.487,0,0,0,.157.026c.421,0,.765-.564.765-1.085V6.828C17.113,6.364,16.743,5.752,16.3,5.752Zm-5.863,6.783a.44.44,0,0,1-.44.439H4.644a.44.44,0,0,1-.439-.439V7.465a.44.44,0,0,1,.439-.439H10a.44.44,0,0,1,.44.439Zm5.356-.029a28.828,28.828,0,0,1-2.26-1.844l-.021-.019-.022-.018-.009-.008c-.16-.132-.354-.292-.44-.384V9.757a2.612,2.612,0,0,1,.4-.345l.021-.015.02-.017c.766-.624,1.655-1.323,2.309-1.81Z",
    style: {
      fill: "#005a7d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxConferance);
export default __webpack_public_path__ + "static/media/bxConferance.78b8f3f7d9618902a2a35449a55b3ced.svg";
export { ForwardRef as ReactComponent };